import axios from 'axios'

// Refund transaction
const getAll = async (iniDate, endDate, type) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/log-indicator/list`, { 
    iniDate, 
    endDate,
    type
  })
  return data
}

export {
  getAll
}
